import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class NotificationJob  {
    _originalTypeClassName = "zPMO.BO.NotificationJob";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
NotificationJob.translate = translateService;
}
this.Emails = [];
this.Id = null;
this.ScheduleDate = null;
this.Status = null;
this.IsApproved = false;
this.TargetClassName = null;
this.TargetClassId = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ScheduleDate:any;
Status:any;
IsApproved:any;
TargetClassName:any;
TargetClassId:any;
Type:any;
Emails:any;
static setType = ($this, value) => {
var oldValue = $this.Type;
$this.Type = value;
if (value != null) {
}
}
static setEmails = ($this, items) => {
                if (items == null) items = [];
                if ($this.Emails == null) $this.Emails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Emails.length > 0) {
                    Domain.NotificationJob.removeEmails($this, $this.Emails[0]);
                }

                Domain.NotificationJob.addManyEmails($this, copyItems);
            }
static addManyEmails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.NotificationJob.addEmails($this, items[i]);
                }
            }
static addEmails = ($this, item) => {
                if ($this.Emails == null) $this.Emails = [];
                if (item == null || $this.Emails.indexOf(item) > -1) return;
                $this.Emails.push(item);
}
static addRangeEmails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.NotificationJob.addEmails($this, item));
            }
static removeEmails = ($this, item) => {
                if ($this == null || $this.Emails == null || $this.Emails.indexOf(item) === -1) return;
                var _index = $this.Emails.indexOf(item);
                $this.Emails.splice(_index, 1);
}
static clearEmails = ($this) => { $this.Emails = null; }

static Execute(): any{}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}